import React from 'react'

const RecorderSettings: React.FC = () => {
  return	(
    <></>
  )
};

export default RecorderSettings;